import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import PlayerClassic from 'services/sports/mma/player/classic';
import PlayerShowDown from 'services/sports/mma/player/showdown';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: PlayerClassic,
    [Const.GAME_TYPE_SHOWDOWN]: PlayerShowDown,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
